import { CaseReturnRequestType, LegalEntityEnum } from '@onrunning/backstage-models';
interface ReturnRequestTypeByMinModel {
  requestType: CaseReturnRequestType;
  min: number;
}

export const returnRequestTypeByLegalEntity: Record<string, ReturnRequestTypeByMinModel> = Object.freeze({
  [LegalEntityEnum.ON_US]: { requestType: CaseReturnRequestType.Pickup, min: 150 },
  [LegalEntityEnum.ON_CA]: { requestType: CaseReturnRequestType.Pickup, min: 150 },
  [LegalEntityEnum.ON_AG]: { requestType: CaseReturnRequestType.Pickup, min: 80 },
  [LegalEntityEnum.ON_CH]: { requestType: CaseReturnRequestType.Pickup, min: 80 },
  [LegalEntityEnum.ON_UK]: { requestType: CaseReturnRequestType.Pickup, min: 80 },
  [LegalEntityEnum.ON_AU]: { requestType: CaseReturnRequestType.Pickup, min: 0 },
  default: { requestType: CaseReturnRequestType.Label, min: 0 },
});
